var i18n = {};
var defaultLocale = 'en-us';

i18n['en-us'] = require('./en-us.js');

i18n['en-lk'] = require('./en-lk.js');

i18n['th-th'] = require('./th-th.js');

i18n['my-mm'] = require('./my-mm.js');

i18n['tl-ph'] = require('./tl-ph.js');

i18n['vi-vn'] = require('./vi-vn.js');

i18n['en-mm'] = require('./en-mm.js');

i18n['ms-my'] = require('./ms-my.js');

i18n['bn-bd'] = require('./bn-bd.js');

i18n['si-lk'] = require('./si-lk.js');

i18n['in-id'] = require('./in-id.js');

i18n['en-sg'] = require('./en-sg.js');

i18n['en-bd'] = require('./en-bd.js');

i18n['zh-tw'] = require('./zh-tw.js');

i18n['zh-cn'] = require('./zh-cn.js');


for (var locale in i18n) {
  if(!i18n.hasOwnProperty(locale)){
    continue;
  }
  if(locale == defaultLocale){
    continue;
  }
  for(var key in i18n[defaultLocale]){
    if(!i18n[defaultLocale].hasOwnProperty(key)){
      continue;
    }
    if(!i18n[locale].hasOwnProperty(key)){
      i18n[locale][key] = i18n[defaultLocale][key];
    }
  }
}

//把其它信息也加上去
i18n.appName = 'lazada-im-core-intl';
i18n.groupName = 'im-core';
i18n.defaultLocale = defaultLocale;

module.exports = i18n;

